import { render } from "./LocalPreloader.vue?vue&type=template&id=5224030a"
import script from "./LocalPreloader.vue?vue&type=script&lang=js"
export * from "./LocalPreloader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__